<template >
<div >
  <v-container grid-list-xs>
    <br> 
    <v-divider></v-divider>
    <br>
    <v-toolbar color="primary" dark>
      <v-toolbar-title>
        <div class="font-weight-bold not-f7 pl-1 text-uppercase font-italic">{{selectedType}} EVENTS</div>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn outlined class="mr-2" @click="setToday" v-if="calendar">
          Today
      </v-btn>
      <v-menu bottom right class="mr-2" v-if="calendar">
          <template v-slot:activator="{ on }">
          <v-btn
              outlined=""
              v-on="on"
          >
              <span>{{ typeToLabel[type] }}</span>
              <v-icon right>mdi-menu-down</v-icon>
          </v-btn>
          </template>
          <v-list>
            <v-list-item @click="type = 'day'">
                <v-list-item-title>Day</v-list-item-title>
            </v-list-item>
            <v-list-item @click="type = 'week'">
                <v-list-item-title>Week</v-list-item-title>
            </v-list-item>
            <v-list-item @click="type = 'month'">
                <v-list-item-title>Month</v-list-item-title>
            </v-list-item>
            <v-list-item @click="type = '4day'">
                <v-list-item-title>4 days</v-list-item-title>
            </v-list-item>
          </v-list> 
      </v-menu> 
      <v-btn @click="calendar=false" icon outlined=""   :class="calendar?' ml-2 mr-2':'white ml-2 mr-2'"><v-icon :color="calendar?'':'primary'" size="30">dashboard</v-icon></v-btn>
      <v-btn @click="calendar=true" icon outlined="" :class="!calendar?' mr-2':'white mr-2'"><v-icon :color="!calendar?'':'primary'" size="30">event</v-icon></v-btn>  
    </v-toolbar>
    <v-row class="fill-height">
        <v-col sm="8" cols="12">
          <!-- CALENDAR -->
          <v-sheet v-if="calendar">
            <v-toolbar color="primary"  dark="" > 
              <v-btn fab text small @click="prev">
                  <v-icon small>mdi-chevron-left</v-icon>
              </v-btn>
              <v-layout row wrap justify-center="">
                <v-toolbar-title>{{ title }}</v-toolbar-title> 
                
              </v-layout>
              <v-btn fab text small @click="next">
                  <v-icon small>mdi-chevron-right</v-icon>
              </v-btn> 
            </v-toolbar>
            <v-divider></v-divider> 
            <v-sheet height="500">
                <v-calendar
                  ref="calendar"
                  v-model="focus"
                  color="primary"
                  :events="sortedEvents"
                  :event-color="getEventColor"
                  :event-margin-bottom="3"
                  :now="today"
                  :type="type"
                  @click:event="showEvent" 
                  @change="updateRange"
                  ></v-calendar>
                <v-menu
                  v-model="selectedOpen"
                  :close-on-content-click="false"
                  :activator="selectedElement"
                  max-width="500px"
                  offset-x
                  >
                  <v-card
                      color="grey lighten-4"
                      min-width="350px"
                      
                      flat
                  >
                      <v-toolbar
                        :color="selectedEvent.color"
                        dark  class="pa-1">
                        <v-btn size="50" icon>
                            <v-icon size="50">event</v-icon>
                        </v-btn>
                        <div class="pa-2 font-italic">
                          <v-toolbar-title v-html="'From: '+not.convertDate(selectedEvent.start)"></v-toolbar-title>
                          <v-toolbar-title v-html="'To: '+not.convertDate(selectedEvent.end)"></v-toolbar-title> 
                        </div>
                        <div class="flex-grow-1"></div>
                        <v-btn icon @click="selectedOpen = false">
                            <v-icon size="35">mdi-close</v-icon>
                        </v-btn> 
                      </v-toolbar>
                      <v-card-text>
                        <div class="font-weight-bold not-f6 pt-2 pb-4">{{selectedEvent.name}}</div>
                        <div>{{selectedEvent.details}}</div>
                      </v-card-text>
                      <v-card-actions>
                        <v-btn
                            text
                            color="secondary"
                            @click="selectedOpen = false" >
                            Cancel
                        </v-btn>
                      </v-card-actions>
                  </v-card>
                </v-menu>
            </v-sheet> 
          </v-sheet>

          <div v-else> 
            <v-row>
              <v-col sm="6" xl="12"  v-for="(study, index) in p_events?p_events.list:0" :key="index">
                  <v-card :height="'100%'">
                      <v-layout column="" fill-height class="px-3">
                          <v-toolbar max-height="50" :color="study.color.hex" dark>
                              <v-icon class="pr-1">event</v-icon>
                              <v-toolbar-title>
                                  {{study.title}}
                              </v-toolbar-title>
                              <v-spacer></v-spacer>
                              <!-- <v-btn @click="deleteEvent(study.key)" icon=""><v-icon>delete</v-icon></v-btn> -->
                          </v-toolbar>

                          <v-card-text> 
                              <!-- <v-layout row wrap class="py-2">
                              </v-layout> -->
                                  <div class="font-weight-bold">FROM: {{not.convertDate(study.startDate)}}</div>  
                                  <div class="font-weight-bold">TO: {{not.convertDate(study.endDate)}}</div> 
                              <div>{{study.desc}}</div>
                          </v-card-text>
                          <v-spacer/><v-spacer/>
                          <v-divider></v-divider>
                          <v-card-actions class="pb-5" >
                              <v-layout >
                                  <v-spacer></v-spacer>
                                  <!-- <v-btn cl :color="study.color.hex" dark text="" to="/events">View</v-btn> -->
                              </v-layout>
                          </v-card-actions>  
                      </v-layout>     
                  </v-card> 
              </v-col>
            </v-row>
            <v-divider></v-divider>
            <div class="px-5">
              <v-pagination
                v-model="page_current"
                class="mt-4"
                :length="p_events?p_events.pages:0"/> 
              </div> 
          </div>
        </v-col>
        <!-- SIDE -->
        <v-col sm="4">
            <v-layout column=""> 
              <div class="pl-3 pt-3">
                  <div class="not-f6 font-weight-bold pb-3">Event Types</div>
                  <v-divider></v-divider>
                  <v-divider></v-divider>
                  <v-list single-line dense="" color="white">
                      <v-sheet>
                          <v-list-item @click="selectType('All')"  >
                              <v-list-item-icon v-if="selectedType==='All'"><v-icon color="primary">check</v-icon></v-list-item-icon>
                              <v-list-item-content :class="selectedType==='All'?'primary--text':''">All</v-list-item-content> 
                          </v-list-item>
                          <v-divider></v-divider>  
                      </v-sheet>
                      <v-sheet v-for="(event, index) in eventTypesTopic" :key="index">
                          <v-list-item @click="selectType(event.title)" >
                              <v-list-item-icon v-if="selectedType===event.title"><v-icon color="primary">check</v-icon></v-list-item-icon>
                              <v-list-item-content :class="selectedType===event.title?'primary--text':''">{{event.title}} </v-list-item-content>
                               
                          </v-list-item>
                          <v-divider></v-divider>  
                      </v-sheet>
                  </v-list>
              </div> 
              <div class="pl-3 pt-5">
                  <div class="not-f6 font-weight-bold pb-2">Event Occasions</div>
                  <v-divider></v-divider>
                  <v-divider></v-divider>
                  <v-list single-line dense="" color="white">
                      <v-sheet v-for="(event, index) in eventTypesOccasion" :key="index">
                          <v-list-item @click="selectType(event.title)">
                                <v-list-item-icon v-if="selectedType===event.title"><v-icon color="primary">check</v-icon></v-list-item-icon>
                              <v-list-item-content :class="selectedType===event.title?'primary--text':''">{{event.title}} </v-list-item-content> 
                          </v-list-item>
                          <v-divider></v-divider>  
                      </v-sheet>
                  </v-list>
              </div>
          </v-layout>
        </v-col>
    </v-row> 
  </v-container>
   
</div>
</template>

<script>
  let pageName = "Events"
  export default {
    name:pageName,
    props:["not"],
    data: () => ({
      page_current:1,
      page_size:10,
      calendar:false,

      today: new Date().toISOString().slice(0,10),
      focus: new Date().toISOString().slice(0,10),
      type: 'month',
      typeToLabel: {
        month: 'Month',
        week: 'Week',
        day: 'Day',
        '4day': '4 Days',
      },
      start: null,
      end: null,
      selectedEvent: {},
      selectedElement: null,
      selectedOpen: false,
      selectedType:"All", 
      images:[
          {src:require(`@/assets/awrim/group/g6.jpeg`),local:true},  
      ],
    }),
    mounted() {
        this.not.NotHeaderNT({
            notShow:true,
            notType:"image",
            notImages:this.images,
            notText:false,
            notIndicators:true,
            notHeight:300,
        })
    },
    computed: {
      title () {
        const { start, end } = this
        if (!start || !end) {
          return ''
        } 
        const startMonth = this.monthFormatter(start)
        const endMonth = this.monthFormatter(end)
        const suffixMonth = startMonth === endMonth ? '' : endMonth

        const startYear = start.year
        const endYear = end.year
        const suffixYear = startYear === endYear ? '' : endYear

        const startDay = start.day + this.nth(start.day)
        const endDay = end.day + this.nth(end.day)

        switch (this.type) {
          case 'month':
            return `${startMonth} ${startYear}`
          case 'week':
          case '4day':
            return `${startMonth} ${startDay} ${startYear} - ${suffixMonth} ${endDay} ${suffixYear}`
          case 'day':
            return `${startMonth} ${startDay} ${startYear}`
        }
        return ''
      },
      monthFormatter () {
        return this.$refs.calendar.getFormatter({
          timeZone: 'UTC', month: 'long',
        })
      },
      us(){
          return this.not.us
      },
      loading(){  
          return this.not.loading
      },
      processes(){  
          return this.not.processes
      }, 
      responses(){  
          return this.not.responses
      },
      events(){
          return this.$store.getters.getEvents
      },
      eventTypes(){
          return this.$store.getters.getEventTypes
      },
      eventItems(){
          if (!this.eventTypes) {
              return  null
          }
          let item = []
          this.eventTypes.forEach(event => {
              let occasion = event.occasion?"occasion":""
              item.push(event.title)
          });
          return item
      },
      eventTypesOccasion(){
          if (!this.eventTypes) {
              return  null
          }
          return this.eventTypes.filter(event=>{
              return event.occasion
          })
      },
      eventTypesTopic(){
          if (!this.eventTypes) {
              return  null
          }
          return this.eventTypes.filter(event=>{
              return !event.occasion
          })
      },
      eventsSize(){
          let bs = this.events
          return bs?bs.length:0
      },
      eventTypesSize(){
          let bs = this.eventTypes
          return bs?bs.length:0
      },
      sortedEvents(){
        if (!this.events) {
              return  null
          }
          let ev = this.events.filter(e=>{
              if (this.selectedType==="All") {
                  return true
              }
              return e.eventType == this.selectedType
          })
          let list = [...ev].sort(this.not.dynamicSort("i",false)) 
          let newEvents = []
          list.forEach(ev => {
            newEvents.push({
              start:ev.startDate,
              end:ev.endDate,
              details:ev.desc,
              name:ev.title,
              color:ev.color.hexa
            })
          });
          return newEvents
      },
      p_events(){ 
          if (!this.events) {
              return  null
          }
          let ev = this.events.filter(e=>{
              if (this.selectedType==="All") {
                  return true
              }
              return e.eventType == this.selectedType
          })
          let list = [...ev]
          list.sort(this.not.dynamicSort("i",false)) 
          return this.not.pagination(list,this.page_current,this.page_size)
      }

    },
    methods: {
      viewDay ({ date }) {
        this.focus = date
        this.type = 'day'
      },
      getEventColor (event) {
        return event.color
      },
      setToday () {
        this.focus = this.today
      },
      prev () {
        console.log('1');
        
        this.$refs.calendar.prev()
      },
      next () {
        this.$refs.calendar.next()
      },
      showEvent ({ nativeEvent, event }) {
        const open = () => {
          this.selectedEvent = event
          this.selectedElement = nativeEvent.target
          setTimeout(() => this.selectedOpen = true, 10)
        }

        if (this.selectedOpen) {
          this.selectedOpen = false
          setTimeout(open, 10)
        } else {
          open()
        }

        nativeEvent.stopPropagation()
      },
      updateRange ({ start, end }) {
        // You could load events from an outside source (like database) now that we have the start and end dates on the calendar
        this.start = start
        this.end = end
      },
      nth (d) {
        return d > 3 && d < 21
          ? 'th'
          : ['th', 'st', 'nd', 'rd', 'th', 'th', 'th', 'th', 'th', 'th'][d % 10]
      },
      selectType(type){
          this.selectedType = type
      },
      clicked(){

      }
    },
  }
</script>
